import axios from 'axios';


export const getClient = () => {

  const options = {
    baseURL: process.env.REACT_APP_SOURCE_URL
  };

  const client = axios.create(options);

  // Add a request interceptor
  client.interceptors.request.use(
    async request => {

      if (request.headers?.disable_cache) {
        request.headers = {
          'Authorization': localStorage.getItem('token'),
          'disable_cache': request.headers?.disable_cache,
        }

      } else {
        request.headers = {
          'Authorization': localStorage.getItem('token'),
        }
      }


      return request;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  // Add a response interceptor
  client.interceptors.response.use(
    response => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        window.location.replace('/login');
      }
      // 402 Payment Required = Evaligo credit cap hit. Broadcast a
      // global event so the RequestBetaUpgradeModal (mounted once at
      // the app shell) can pop without every screen having to wire it
      // up explicitly. The body shape mirrors the backend
      // CreditLimitExceeded.to_dict() — see credit_middleware.py.
      if (error.response && error.response.status === 402) {
        try {
          window.dispatchEvent(new CustomEvent('credit-limit-reached', {
            detail: error.response.data || { scope: 'org' },
          }));
        } catch (e) {
          // No-op: CustomEvent unavailable in legacy IE — modal won't pop
          // but the original 402 still propagates to the caller below.
        }
      }
      return Promise.reject(error);
    },
  );

  return client;
};